import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import UserStatusRow from './UserStatusRow';

export default class UserStatusChart extends PureComponent {
  static propTypes = {
    timestamps: PropTypes.array
  };

  indexToTimeOfDay() {
    const arr = [...Array(24).keys()];
    const items = arr.map(i => {
      const mmt = moment().startOf('day');
      return mmt
        .add(i, 'hours')
        .format('ha')
        .slice(0, -1);
    });
    return items;
  }

  getClusteredTimestamps() {
    const { timestamps } = this.props;
    const cluster = {};
    timestamps.forEach(timestamp => {
      const m = moment(timestamp);
      const date = m.format('ddd DD-MMM');
      // Your moment at midnight
      const mmtMidnight = m.clone().startOf('day');
      // Difference in minutes
      const diffMinutes = m.diff(mmtMidnight, 'minutes');
      cluster[date] = cluster[date] || [];
      cluster[date].push(diffMinutes);
    });
    return cluster;
  }

  render() {
    const { timestamps } = this.props;
    const timestampsByDate = this.getClusteredTimestamps();
    Object.keys(timestampsByDate).map(date => console.log(date));
    return (
      <div>
        total time stamps: {timestamps.length} <br />
        <div className="user-chart-row">
          <div className="row-label">&nbsp;</div>
          <div className="row-data">
            <div className="scale-container">
              {this.indexToTimeOfDay().map((item, idx) => (
                <div key={idx} className="scale-item">
                  {item}
                </div>
              ))}
            </div>
          </div>
          <div className="row-stats">&nbsp;</div>
        </div>
        {Object.keys(timestampsByDate).map(date => (
          <UserStatusRow
            key={date}
            date={date}
            timestamps={timestampsByDate[date]}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Users/Dashboard/UserStatusChart.js